import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { useBreadcrumbForAd } from '@sbt-web/breadcrumbs';
import { AdItem, ItemGeo } from '@sbt-web/network/types';
import { TuttaItalia } from '@sbt-web/utils';
import { adTypesLabelsMap, adTypesToSlugMap } from '@/shared/tools/search/values';
export interface Props {
  item: AdItem;
}
const DetailBreadcrumbs: FC<Props> = t0 => {
  const $ = _c(8);
  const {
    item
  } = t0;
  const adType = item.type.key;
  let selectedGeo = item.geo;
  if (selectedGeo.region.id === TuttaItalia.id) {
    selectedGeo = undefined;
  }
  const t1 = adTypesLabelsMap[adType];
  const t2 = adTypesToSlugMap[adType];
  let t3;
  if ($[0] !== adType || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      id: adType,
      label: t1,
      parameterName: t2
    };
    $[0] = adType;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== item.category.id || $[5] !== selectedGeo || $[6] !== t3) {
    t4 = {
      adTypeData: t3,
      assetsBase: process.env.NEXT_PUBLIC_ASSETS_BASE_URL,
      origin: process.env.NEXT_PUBLIC_ENV_BASE_URL,
      categoryId: item.category.id,
      geo: selectedGeo
    };
    $[4] = item.category.id;
    $[5] = selectedGeo;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    breadcrumbs
  } = useBreadcrumbForAd(t4);
  return breadcrumbs;
};
export default DetailBreadcrumbs;